import { copyToClipboard } from "@/helpers/ClipboardHelpers";
import Tooltip from "@/tooltip";
import { ClipboardIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { format, parse } from "date-fns";
import { connect } from "react-redux";
import { Actions } from "../../../store/actions/employeeActions";

const stringToDate = (date) => {
    if (!date) return ''
    try {
        const newDate = parse(date.substring(0, 10), 'yyyy-MM-dd', new Date())
        return newDate
    } catch (error) {
        console.error(error)
        return ''
    }
}

const dateToString = (date) => {
    if (!date) return ''
    try {
        const newDate = format(date, 'dd MMM yyyy')
        return newDate
    } catch (error) {
        console.error(error)
        return ''
    }
}

const ChildRelatedLeave = ({
    child,
    leave,
    isLast,
    isAdmin,
    leaveTypeOptionName,
    toggleChildLeaveModal
}) => {
    const { id: childId, reference } = { ...child }
    const { id: leaveId, date, dateTo, applicationDate, type, status } = { ...leave }
    return (
        <div
            key={`child[${childId}]-leave[${leaveId}]`}
            style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(7, minmax(0, 1fr))", padding: '1rem', borderBottom: isLast ? undefined : 'solid rgb(244,244,244) 4px' }}>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{reference}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{dateToString(stringToDate(applicationDate))}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{dateToString(stringToDate(date))}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{dateToString(stringToDate(dateTo))}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{leaveTypeOptionName}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center' }}>
                <h5>{status}</h5>
            </div>
            <div style={{ gridColumn: "span 1 / span 7", textAlign: 'center', paddingRight: '4rem' }}>
                <div
                    onClick={() => toggleChildLeaveModal(child, leave)}
                    className='btn btn-xs btn-default pull-right'
                    style={{ marginLeft: 5 }}>
                    <Tooltip content={`Edit Leave`}>
                        <PencilSquareIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                    </Tooltip>
                </div>
                {isAdmin ?
                    <div
                        onClick={() => copyToClipboard(leaveId)}
                        className='btn btn-xs btn-default pull-right'
                        style={{ marginLeft: 5 }}>
                        <Tooltip content={`Copy Leave ID`}>
                            <ClipboardIcon className="h-5 w-5" style={{ marginTop: "3px" }} />
                        </Tooltip>
                    </div>
                    : null}
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const [leaveTypeSettings, leaveTypes] = [state.leave?.leaveSettings?.leaveTypes, state.leave?.leaveTypes]
    const leaveTypeOptions = leaveTypes
        ?.map(item => ({ ...item, ...leaveTypeSettings?.find(setting => setting?.id == item?.id) }))
        ?.map(leaveType => ({
            value: leaveType.id,
            label: leaveType.name,
            applyIfBalanceAvailable: !!leaveType.applyIfBalanceAvailable,
        }))
    const { leave } = ownProps
    const leaveTypeOptionName = leaveTypeOptions?.find(item => item.value == leave.type)?.label
    return {
        leaveTypeOptionName,
        isAdmin: state?.my?.profile?.isAdmin,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    toggleChildLeaveModal: (child, leave) => dispatch(Actions.toggleChildLeaveModal({ open: true, child, leave })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChildRelatedLeave);
